export default __webpack_public_path__ + "static/media/sh-link-disabled.d0710911.svg";